import { t } from "@lingui/core/macro";

/** UI vocabulary for the holiday identifiers returned by @kehila/zmanim. */
export function restHolidayName(holiday) {
    switch (holiday) {
        case "ROSH_HASHANA": return t`Roch Hachana`;
        case "YOM_KIPPUR": return t`Yom Kippour`;
        case "SUKKOT": return t`Souccot`;
        case "SHMINI_ATZERET": return t`Chemini Atseret`;
        case "SIMCHAT_TORAH": return t`Sim'hat Torah`;
        case "PESACH": return t`Pessa'h`;
        case "SHAVUOT": return t`Chavouot`;
        default: return null;
    }
}

export function restPeriodTitle(period, locale = "fr") {
    if (!period) return null;
    const holidays = period.occasion.holidays.map(restHolidayName).filter(Boolean);
    if (holidays.length) {
        return period.occasion.hasShabbat
            ? `${holidays.join(" · ")} · ${t`Chabbat`}`
            : holidays.join(" · ");
    }
    const parasha = locale === "he"
        ? (period.occasion.parasha?.hebrew || period.occasion.parasha?.latin)
        : period.occasion.parasha?.latin;
    return parasha ? `${t`Chabbat`} ${parasha}` : t`Chabbat`;
}

export function restPeriodRowLabel(item) {
    if (item.kind === "entry") {
        if (item.holiday && item.shabbat) return t`Entrée de Chabbat et de la fête`;
        return item.holiday ? t`Entrée de la fête` : t`Entrée de Chabbat`;
    }
    if (item.kind === "candles") {
        return item.afterNightfall ? t`Allumage après la nuit (flamme existante)` : t`Allumage avant Chabbat`;
    }
    if (item.holiday && item.shabbat) return t`Sortie de Chabbat et de la fête`;
    return item.holiday ? t`Fin de la fête` : t`Sortie de Chabbat`;
}
